

export class LoginOutputSubMenuData implements ILoginOutputSubMenuData {
    /** The auto-generated id of the tbl_application_sub_menu */
    application_sub_menu_id!: number;
    /** The main menu name with 100 character limit */
    menu_name!: string;
    /** The sub menu icon with 2048 character limit */
    menu_url!: string;
    /** The user rights */
    action_type!: number;

    constructor(data?: ILoginOutputSubMenuData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application_sub_menu_id = _data["application_sub_menu_id"];
            this.menu_name = _data["menu_name"];
            this.menu_url = _data["menu_url"];
            this.action_type = _data["action_type"];
        }
    }

    static fromJS(data: any): LoginOutputSubMenuData {
        data = typeof data === 'object' ? data : {};
        let result = new LoginOutputSubMenuData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application_sub_menu_id"] = this.application_sub_menu_id;
        data["menu_name"] = this.menu_name;
        data["menu_url"] = this.menu_url;
        data["action_type"] = this.action_type;
        return data; 
    }
}

export interface ILoginOutputSubMenuData {
    /** The auto-generated id of the tbl_application_sub_menu */
    application_sub_menu_id: number;
    /** The main menu name with 100 character limit */
    menu_name: string;
    /** The sub menu icon with 2048 character limit */
    menu_url: string;
    /** The user rights */
    action_type: number;
}

